<div
  class="tabs-container"
  [attr.data-size]="size"
  [attr.data-variant]="variant"
  [attr.data-full-width]="fullWidth"
  role="tablist"
>
  <umss-tab
    *ngFor="let tab of tabs; trackBy: trackByTabId"
    [label]="tab.label"
    [content]="tab.content || 'Label'"
    [iconName]="tab.iconName"
    [counter]="tab.counter"
    [fullWidth]="tabsDistribution === 'fill'"
    [showCounter]="!!tab.counter"
    [size]="size"
    [active]="isTabActive(tab.id)"
    [disabled]="!!tab.disabled"
    [attr.role]="'tab'"
    [attr.aria-selected]="isTabActive(tab.id)"
    [attr.aria-controls]="tab.id + '-panel'"
    (tabClick)="onTabClick(tab.id)"
  >
  </umss-tab>

  <!-- Content projection for custom tab content -->
  <ng-content></ng-content>
</div>
